// extracted by mini-css-extract-plugin
export var deleteIcon = "_sz-5";
export var deleteOption = "_sz-3";
export var divider = "_sz-2";
export var downloadIcon = "_sz-4";
export var drawer = "_sz-0";
export var drawerFooter = "_sz-6";
export var drawerOpen = "_sz-1";
export var highlighted = "_sz-7";
export var lighterHighlight = "_sz-8";